import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import {
    Navigation,
    Pagination,
} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const pcSlider = document.querySelectorAll('.product-categories .pc-slider');

    pcSlider.forEach(slider => {
        new Swiper(slider, {
            modules: [Navigation, Pagination],
            loop: true,
            autoHeight: false,
            spaceBetween: 32,
            slidesPerView: 1,
            autoplay: {
                delay: 4500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            pagination: {
                el: slider.querySelector('.sp-pagination'),
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                991: {
                    slidesPerView: 3,
                },
            },
        });
    });
});